import Vue from 'vue'
import VueRouter from 'vue-router'
const WhiteViewer = () => import('../views/WhiteViewer')

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect:"/parkoverview",
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/Home.vue'),
        meta:{
            title:'首页'
        },
        children:[
            {
                path: '/parkoverview',
                name: 'parkoverview',
                component: () => import('../views/pages/ParkOverView'),
            }
        ]
    },
    {
        path: "/whiteViewer",
        name: "whiteViewer",
        component: WhiteViewer
    },
    {
        path:'/404',
        name:"404",
        component: () => import('../views/NotFound.vue'),
    },
    {
        path:"*",
        redirect:"/404"
    }
]

const router = new VueRouter({
    routes
})

export default router
